<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
        <el-breadcrumb-item>考试记录</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="searchForm">
          <el-form-item>
              <el-date-picker
                v-model="searchForm.date"
                type="daterange"
                range-separator="至"
                start-placeholder="考试开始日期"
                end-placeholder="考试结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                >
              </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="handleSearch">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>

      <!--列表-->
      <el-table :data="exams" highlight-current-row v-loading="loading" border style="width: 100%;">
        <el-table-column type="index" label="序号" width="60" fixed="left" align="center"></el-table-column>
        <el-table-column prop="testName" label="名称" align="center" width="800" ></el-table-column>
        <el-table-column prop="totalScore" label="得分" width="100"  align="center" ></el-table-column>
        <el-table-column prop="surplusLockTimes" label="可考次数" width="120" align="center"></el-table-column>
        <el-table-column prop="examTime" label="考试时间" width="120" align="center"></el-table-column>
         <el-table-column prop="passExam" label="是否合格" width="120" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="180"  align="center"></el-table-column>
        <el-table-column prop="updateDate" label="更新时间" width="180"  align="center"></el-table-column>
        <el-table-column label="操作" fixed="right"  align="center"  width="220" >
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="showDetailDialog(scope.$index,scope.row)">详情</el-button>
            <!-- <el-button v-if="scope.row.surplusLockTimes>0" type="default" size="mini" @click="handleReExam(scope.$index,scope.row)">重考</el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <!--分页工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]"
          :page-size="10" background layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
      </el-col>
    </el-col>

    <ExamVue ref="childExamDom" @childCallback="childCallback"></ExamVue>
  </el-row>
</template>
<script>
import util from '../../common/util'
import API from '../../api/exam/api_exam';
import examvue  from './exam';
export default {
    data(){
        return{
            exams:[],
            loading:false,
            total: 0,
            page: 1,
            limit: 10,
            searchForm:{
              date:''
            }
        }
    },
    methods:{
        //查询函数
        search:function(){
            let that = this;
            let startDate='';
            let endDate='';
            if(that.searchForm.date && that.searchForm.date.length>0){
                startDate = that.searchForm.date[0];
                endDate=that.searchForm.date[1];
            }
            let params = {
                page: this.page,
                limit: this.limit,
                startDate:startDate,
                endDate:endDate
            };
            //加载
            API.getList(params)
                .then(
                    function (result) {
                    that.loading = false;
                    if (result && result.code == 200) {
                      console.log(result.data);
                        if(result.data  && result.data.records)
                        {
                            that.total= result.data.total;
                            that.exams=result.data.records;
                        }
                    }
                    },
                    function (err) {
                    that.loading = false;
                    that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000
                    });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    console.log(error);
                    that.$message.error({
                    showClose: true,
                    message: "请求出现异常",
                    duration: 2000
                    });
                });
        },
        //查询
        handleSearch:function(){
            this.page=1;
            this.total=0;
            this.search();
        },
        //分页切换每页条数
        handleSizeChange:function(val){
            this.limit = val;
            this.search();
        },
        //分页切换页码
        handleCurrentChange:function(val){
            this.page = val;
            this.search();
        },
        showDetailDialog:function(index,row){
          let that =this;
          that.$refs["childExamDom"].examFormVisible=true;
          that.$refs["childExamDom"].showButtonvisible="display:none";
          that.$refs["childExamDom"].getDetail(row.id);
        },
        handleReExam:function(index,row){
          let that =this;
          that.$refs["childExamDom"].examFormVisible=true;
          that.$refs["childExamDom"].search(row.testId,index);
          that.$refs["childExamDom"].examId=row.id;
          that.$refs["childExamDom"].rateId=row.rateId;
          that.$refs["childExamDom"].handleSubmit=function(){
            that.$refs["childExamDom"].resubmit();
          }
        },
        childCallback:function(index,val){
          let that = this;
          console.log(that.exams[index]);
          that.exams[index].surplusLockTimes= that.exams[index].surplusLockTimes-1;
          if(val!=null){
            that.exams[index].totalScore= val;
          }
        }
    },
     //页面load加载
     mounted() {
      this.handleSearch();
    },
    components: {
      'ExamVue': examvue  //
    }
    
    
}
</script>


// WEBPACK FOOTER //
// userexam.vue?37f605ae